module.exports = __webpack_public_path__ + "static/smartstore-1d8789bdca7d3cd3356cd8fef4fc9293.png";